import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ContactForm.css";
import sendEmail from "./EmailSender.js";
import CircularProgress from "@mui/material/CircularProgress";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css"; // Import the necessary styles for PhoneInput
import Swal from 'sweetalert2';


const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    category: "LLMInsight",
    phoneNumber: "",
    message: "",
    organizationName: "",
    role: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(true);

  const handlePhoneChange = (value) => {
    const phoneValue = value ? String(value) : "";
    setFormData((prevState) => ({ ...prevState, phoneNumber: phoneValue }));
    const valid = isValidPhoneNumber(phoneValue);
    console.log("is valid", valid);
    setIsPhoneValid(valid); // Update phone validity state
    // setIsPhoneValid(true); // Clear phone error when the user starts typing
  };

  // Clear the success message after 1 minute
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(""); // Clear the success message after 1 minute
      }, 10000); // 1 minute = 60000 milliseconds

      // Cleanup the timer when the component is unmounted or when success changes
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
    setError(""); // Clear error message when the user starts typing
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Regular expressions for validating email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if all fields have a value and validate email and phone number
    if (
      !formData.name ||
      !formData.email ||
      !formData.phoneNumber ||
      !formData.message ||
      !formData.organizationName ||
      !formData.role
      // formData.category === "Select One"
    ) {
      setError("All fields are required. Please check and try again.");
      return;
    }

    if (!emailRegex.test(formData.email)) {
      setError("Please enter a valid email address.");
      return;
    }

    // Check if phone number is valid
    if (!isPhoneValid) {
      setError("Please enter a valid phone number.");
      return;
    }

    setError("");
    setLoading(true);

    // Prepare the data for the API
    const requestData = {
      inquirer_name: formData.name,
      email: formData.email,
      inquiry_about: "LLMInsight",
      phone_number: formData.phoneNumber,
      message: formData.message,
      organization_name: formData.organizationName,
      role_in_organization: formData.role,
    };

    try {
      const response = await axios.post(
        "https://app-acs-dev-eastus.azurewebsites.net/add_inquiry",
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        // Show SweetAlert success popup
        Swal.fire({
          title: 'Success!',
          text: response.data.message || 'Inquiry added successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#073D8D',
          timer: 5000,
          timerProgressBar: true,
        });

        // if (supportEmailSent) {
        const currentDate = new Date();
        const currentDay = currentDate.getDay();
        let message =
          "Thank you for your inquiry. Our team will contact you within 24 hours.";
        if (currentDay === 6 || currentDay === 0) {
          message =
            "Thank you for your inquiry. Our team will contact you on the next business day.";
        }

        // Remove the inline success message since we're using SweetAlert
        // setSuccess(message);
        setLoading(false);

        // } else {
        //   setError(
        //     "There was a problem sending confirmation emails. Please try again later."
        //   );
        // }
        // Send email to support team
        const supportEmailSent = await sendEmail({
          application_name: "LLMInsight.ai",
          env_type: "Production",
          email_subject: "New Inquiry Received",
          message: `Dear Support Team,

We have received a new inquiry with the following details:

Name: ${formData.name}
Email: ${formData.email}
Inquiry Category: ${formData.category}
Phone Number: ${formData.phoneNumber}
Message: ${formData.message}
Organization Name: ${formData.organizationName}
Role in Organization: ${formData.role}

Please follow up with the inquirer as soon as possible.

Best regards,
SST Support Team`,
          receiver_addresses: ["sstofficial@sstglobal.net"],
        });
        setFormData({
          name: "",
          email: "",
          category: "LLMInsight",
          phoneNumber: "",
          message: "",
          organizationName: "",
          role: "",
        });
      } else {
        setError(
          "There was a problem submitting your inquiry. Please try again later."
        );
      }
    } catch (error) {
      setLoading(false);
      setError(
        "There was a problem submitting your inquiry. Please try again later."
      );
    }
  };

  return (
    <div className="contact-form-container">
      <h2 className="contact-form-header">Get In Touch</h2>
      <div className="contact-form-card">
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            className="form-input"
            id="inputName"
            name="name"
            placeholder="Your Name:"
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            className="form-input"
            id="inputEmail"
            name="email"
            placeholder="Your Email:"
            value={formData.email}
            onChange={handleChange}
          />
          {/* <select
            id="inputState"
            className="form-select"
            name="category"
            value={formData.category}
            onChange={handleChange}
          >
            <option value="Other">Other</option>
            <option value="LLMInsight">LLMInsight</option>
            <option value="GenAI">GenAI Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Mobile Development">Mobile Development</option>
            <option value="Manage Existing Cloud">Manage Existing Cloud</option>
            <option value="Migrate to the Cloud">Migrate to the Cloud</option>
            <option value="Consulting Advisory">Consulting Advisory</option>
            <option value="Security Assessment & Compliance Related">
              Security Assessment & Compliance Related
            </option>
          </select> */}

          {/* Phone Input with country code */}
          <PhoneInput
            country="us" // Default country is USA
            id="inputPhone"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handlePhoneChange} // Handle phone input change
            // preferredCountries={["us", "in", "uk"]} // Preferred countries
            placeholder="Enter phone number"
            className="form-input"
            required
            isValid={(valid) => setIsPhoneValid(valid)} // Use the built-in validation
          />
          <input
            type="text"
            className="form-input"
            id="inputOrganizationName"
            name="organizationName"
            placeholder="Your Organization Name:"
            value={formData.organizationName}
            onChange={handleChange}
          />
          <input
            type="text"
            className="form-input"
            id="inputRole"
            name="role"
            placeholder="Your Role in Organization:"
            value={formData.role}
            onChange={handleChange}
          />
          <textarea
            className="form-input"
            id="inputMessage"
            name="message"
            placeholder="Your Message:"
            value={formData.message}
            onChange={handleChange}
            rows="4"
          ></textarea>
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? (
              <CircularProgress color="primary" size={24} />
            ) : (
              "SUBMIT NOW"
            )}
          </button>
          {error && <div className="error-message">{error}</div>}
        </form>
      </div>
      <div>
        <h4 className="qr_text">Scan QR Code to download LLM Insight Deck</h4>
        <img
          src="qr_production.jpeg"
          style={{
            height: "30%",
            width: "30%",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            border: "1px solid rgba(0, 0, 0, 0.3)",
            borderRadius: 10,
          }}
        />
      </div>
    </div>
  );
};

export default ContactForm;
